__webpack_require__.p = "/imanager/";